export default __webpack_public_path__ + "media/reddit.6216f6fa.svg";